<div id="vtz-numbered-list__item-{{num}}" class="vtz-numbered-list__item">
  <div id="vtz-numbered-list__number-container-{{num}}" class="vtz-numbered-list__number-container">
    <span class="vtz-numbered-list__number" i18n>{{num}}</span>
  </div>
  <p class="vtz-numbered-list__text" i18n>
    <ng-content></ng-content>
  </p>
</div>
